import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportDeltaShekelFetch } from './actions';

export const sagasReportDeltaShekel = [
  takeLatest(actionReportDeltaShekelFetch.rejected, workerErrorNotifyThunk),
];
